import { Component, OnInit } from '@angular/core';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-radar',
  templateUrl: './radar.component.html',
  styles: []
})
export class RadarComponent implements OnInit {

  public fileError: string = '';

  constructor() {}
  ngOnInit() {}

  public radarChartLabels: string[] = ['Eating', 'Drinking', 'Sleeping', 'Designing', 'Coding', 'Cycling', 'Running'];
  public radarChartData: any = [
    {data: [65, 59, 90, 81, 56, 55, 40],  label: 'Series A'},
    {data: [28, 48, 40, 19, 96, 27, 100], label: 'Series B'}
  ];
  public radarChartType: string = 'radar';

  public randomize(): void {
    const newData = this.radarChartData.map((series: any) => ({
      label: series.label,
      data:  series.data.map(() => Math.floor(Math.random() * 100) + 1)
    }));
    this.radarChartData   = [...newData];
    this.radarChartLabels = [...this.radarChartLabels];
  }

  /**
   * Formato esperado (hoja "Radar" o primera hoja):
   *   Fila 1: Series   | Velocidad | Potencia | ...   ← cabecera
   *   Fila 2: Equipo A | 85        | 72       | ...
   *   Fila 3: Equipo B | 70        | 88       | ...
   * Filas sin valores numéricos (notas) se ignoran.
   */
  public loadFromExcel(event: any): void {
    this.fileError = '';
    const file = event.target.files[0];
    if (!file) { return; }

    const reader = new FileReader();
    reader.onload = (e: any) => {
      try {
        const workbook = XLSX.read(e.target.result, { type: 'binary' });

        const sheetName = workbook.SheetNames.find(
          n => n.toLowerCase() === 'radar'
        ) || workbook.SheetNames[0];

        const sheet = workbook.Sheets[sheetName];
        const rows: any[][] = XLSX.utils.sheet_to_json(sheet, { header: 1, defval: '' });

        if (rows.length < 2) {
          this.fileError = 'El archivo debe tener al menos una fila de cabecera y una de datos.';
          return;
        }

        const headerRow = rows[0];

        // Keep only rows with at least one numeric value after the first cell
        const dataRows = rows.slice(1).filter(row => {
          return row.slice(1).some((v: any) => v !== '' && !isNaN(Number(v)));
        });

        if (dataRows.length === 0) {
          this.fileError = 'No se encontraron filas de datos válidos.';
          return;
        }

        const firstCell    = dataRows[0][0];
        const firstIsLabel = isNaN(Number(firstCell)) && String(firstCell).trim() !== '';

        let newLabels: string[];
        let newData: any[];

        if (firstIsLabel) {
          newLabels = headerRow.slice(1).filter((v: any) => v !== '').map(String);
          newData   = dataRows.map((row, i) => ({
            label: String(row[0]) || `Series ${i + 1}`,
            data:  row.slice(1, newLabels.length + 1).map((v: any) => Number(v) || 0)
          }));
        } else {
          newLabels = headerRow.filter((v: any) => v !== '').map(String);
          newData   = dataRows.map((row: any[], i: number) => ({
            label: `Series ${i + 1}`,
            data:  row.slice(0, newLabels.length).map((v: any) => Number(v) || 0)
          }));
        }

        if (newData.length === 0 || newLabels.length === 0) {
          this.fileError = 'No se encontraron datos válidos.';
          return;
        }

        this.radarChartLabels = [...newLabels];
        this.radarChartData   = [...newData];

      } catch (err) {
        this.fileError = 'Error al leer el archivo Excel.';
        console.error(err);
      }
    };

    reader.readAsBinaryString(file);
    event.target.value = '';
  }

  public chartClicked(e: any): void { console.log(e); }
  public chartHovered(e: any): void { console.log(e); }
}